import { render, staticRenderFns } from "./IntegrationClickhouse.vue?vue&type=template&id=0c0232a1&scoped=true"
import script from "./IntegrationClickhouse.vue?vue&type=script&lang=js"
export * from "./IntegrationClickhouse.vue?vue&type=script&lang=js"
import style0 from "./IntegrationClickhouse.vue?vue&type=style&index=0&id=0c0232a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0232a1",
  null
  
)

export default component.exports